<template>
	<div style="background: #fcfcfc; padding: 29px 0 20px">
		<div class="designerIn">
			<h4 class="designerInTitle">设计师信息认证</h4>
			<div style="padding: 0 22px" v-loading="loading">
				<!-- 流程条 -->
				<div class="steps_top">
					<el-steps :active="activeTop" align-center>
						<el-step description="提交认证信息"></el-step>
						<el-step :class="cerStatus && cerStatus === 'REJECT'? 'certificationErrorLine': ''"
							description="认证信息审核"></el-step>
						<el-step :class="
                cerStatus && cerStatus === 'REJECT' ? 'certificationError' : ''
              " :description="
                cerStatus && cerStatus === 'REJECT' ? '认证失败' : '完成认证'
              "></el-step>
					</el-steps>
				</div>
				<div v-if="activeTop == 1 || !cerStatus || cerStatus === 'DRAFT'">
					<!-- 用户信息 -->
					<div class="designerInMess">
						<h4>设计师实名认证</h4>
						<!-- 用户认证 -->
						<div class="designerID flex">
							<div class="designerIDmes">
								<el-upload action="/service-center/upload/file/single" :on-success="handleAvatarSuccess"
									class="hiddenInput" :headers="headers" :before-upload="beforeAvatarUpload"
									:disabled="status === 'SUBMIT' || status === 'APPROVE'" :show-file-list="false">
									<img v-if="!backUrl" :src="userInfo.avatar" alt="" />
									<img v-if="backUrl" :src="backUrl" alt="" />
								</el-upload>
								<p>支持PNG、JPG大小不超过1MB</p>
							</div>
							<div class="designerIDmes">
								<el-upload action="/service-center/upload/file/single"
									:before-upload="beforeAvatarUpload" :headers="headers"
									:on-success="handleAvatarSuccess2" class="hiddenInput2"
									:disabled="status === 'SUBMIT' || status === 'APPROVE'" :show-file-list="false">
									<img v-if="!frontUrl" :src="userInfo2.avatar" alt="" />
									<img v-if="frontUrl" :src="frontUrl" alt="" />
								</el-upload>
								<p>支持PNG、JPG大小不超过1MB</p>
							</div>
						</div>
						<!-- 用户个人信息 -->
						<div class="designerIDcon">
							<div class="designerIDconbox flex">
								<div :class="nameMess!==''?'designerIDconboxN flex designerBox_input':'designerIDconboxN flex'" ref="nameRef">
<!--									<i class="mandatory">*</i>-->
									<p style="letter-spacing: 28px">姓名</p>
									<div>
										<!-- <el-input v-model="name" placeholder="请输入姓名" :disabled="status === 'SUBMIT' || status === 'APPROVE'"></el-input> -->
										<input type="text" style="width: 200px" v-model="name" placeholder="请输入姓名"
											:disabled="status === 'SUBMIT' || status === 'APPROVE'" />
										<div class="messagesP">{{nameMess}}</div>
									</div>
								</div>
								<div :class="cardNumValueMess!==''?'designerIDconboxN flex designerBox_input':'designerIDconboxN flex'" ref="cardNumValueRef">
<!--									<i class="mandatory">*</i>-->
									<p>证件号码</p>
									<div>
										<input type="text" style="width: 445px" v-model="cardNumValue"
											placeholder="请输入正确的证件号码"
											:disabled="status === 'SUBMIT' || status === 'APPROVE'" readOnly="true"/>
										<div class="messagesP">{{cardNumValueMess}}</div>
									</div>
								</div>
								<div :class="genderMess!==''?'designerIDconboxN flex designerBox_input':'designerIDconboxN flex'" ref="genderRef">
<!--									<i class="mandatory">*</i>-->
									<p style="letter-spacing: 28px">性别</p>
									<div>
										<span class="span_active" v-for="(items, index) in genderList" :key="index"
											:class="genderIndex == index ? 'span_activeshow' : 'span_active'"
											@click="getGender(index)">{{ items.gender }}</span>
											<div class="messagesP">{{genderMess}}</div>
									</div>
									
								</div>
							</div>
							<div class="designerIDconbox flex" ref="valueRef">
								<div :class="valueMess!==''?'designerIDconboxN flex designerBox_input':'designerIDconboxN flex'">
									<i class="mandatory">*</i>
									<p style="letter-spacing: 28px">地区</p>
									<div>
										<el-cascader v-model="value" :options="options" @change="handleChange"
											class="cascaderInput"></el-cascader>
											<div class="messagesP">{{valueMess}}</div>
									</div>
									
								</div>
								<div :class="addressMess!==''?'designerIDconboxN flex designerBox_input':'designerIDconboxN flex'" ref="addressRef">
									<i class="mandatory">*</i>
									<p>详细地址</p>
									<div>
										<el-input v-model="form.address" placeholder="地址填写"  @keyup.native="onMess1(form.address)"></el-input>
										<!-- <input type="text" placeholder="地址填写" style="width: 541px" v-model="form.address" /> -->
										<div class="messagesP">{{addressMess}}</div>
									</div>
								</div>
							</div>
							<div :class="introductionMess!==''?'designerIDconbox flex designerBox_input':'designerIDconbox flex '" ref="introductionRef">
								<i class="mandatory">*</i>
								<p>个人介绍</p>
								<div>
									<el-input
									  type="textarea"
									  placeholder="请输入个人介绍"
									   v-model="form.introduction"
									  @keyup.native="onMess(form.introduction)"
									 >
									</el-input>
								<!-- <textarea placeholder="必填" v-model="form.introduction" name="" id=""  v-on:keydown='onMess(form.introduction)'
									></textarea> -->
								<div class="messagesP">{{introductionMess}}</div>
								</div>
							</div>
						</div>
					</div>
					<!-- 设计师类型 -->
					<div class="designerClass">
						<div class="desTopClass desCommentClass flex" ref="screenRef">
							<!-- <div class="typeName">分类</div> -->
							<i class="mandatory">*</i>
							<p class="typeName">分类</p>
							<div>
								<div class="print_screen_boxP">
									<p v-for="(item,index) in screenList" :key="index" @click="getPrintScreen(index)"
										:class="printScreenIndex == index ? 'screen_text' : ''">
										{{ item.name }}
									</p>
									<!-- <div class="messagesP">{{screenMess}}</div> -->
								</div>
								<!-- <div
                                    class="flex destoPone"
                                                        style="
                                        padding: 15px 15px 5px;
                                        background: rgb(241, 245, 254);
                                        width: 1000px;
                                    "
                                    v-show="classShow"
                                > -->
								<!-- <p
                                    v-for="(items, index) in screenList[printScreenIndex]
                                      .screenTwo"
                                    :key="index"
                                    :class="printScreenTwoIndex == index ? 'materDetailsT' : ''"
                                    @click="getPrintScreenTwo(index)"
                                    style="cursor: pointer"
                                  >
                                    {{ items.names }}
                                  </p> -->
								<!-- <el-checkbox
                                        :indeterminate="isIndeterminate"
                                        v-model="checkAll"
                                        @change="handleCheckAllChange"
                                        style="margin-right: 20px">全选
                                    </el-checkbox>
                                    <div style="margin: 15px 0"></div>
                                    <el-checkbox-group
                                        v-model="checkedCities"
                                        @change="handleCheckedCitiesChange" v-if="checkedCitiesFlag">
                                        <el-checkbox
                                            v-for="(city, index) in screenList[printScreenIndex].screenTwo"
                                            :label="city"
                                            :key="index"
                                        >{{ city.names }}
                                        </el-checkbox>
                                    </el-checkbox-group> -->
								<!-- </div> -->
							</div>
						</div>
					</div>
					<!-- 擅长类型 -->
					<div class="flex goodAtClass" ref="goodatRef">
						<i class="mandatory">*</i>
						<p class="goodAtClassT">擅长类型</p>
						<div>
							<el-checkbox-group v-model="checkList" @change="handleCheckedListChange">
								<el-checkbox v-for="(city, index) in goodat" :label="city.id" :key="index">{{ city.button }}
								</el-checkbox>
							</el-checkbox-group>
							<div class="messagesP" style="margin:5px 0;padding: 0;">{{goodatMess}}</div>
						</div>
						
					</div>
					<!-- 设计师作品 -->
					<div class="desinerInWorks" v-show="classShows">
						<h4>设计师作品上传</h4>
						<div style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              ">
							<div class="desinerInWorksbox">
								<div class="upload-demoss">
									<div class="upload-demobox">
										<div v-if="imgShow">
											<div class="demoboxAdd">
												<el-upload action="/service-center/upload/file/single"
													:on-success="handleSuccess1" class="hiddenInput" :headers="headers"
													:before-upload="beforeAvatarUpload" accept=".jpg,.jpeg,.png"
													:show-file-list="false">
													<img v-if="!img1" height="215" width="320" :src="workImg" alt="" />
													<img v-if="img1" height="215" width="320" :src="img1" alt="" />
												</el-upload>
												
											</div>
										</div>
									</div>
								</div>
								<div :class="work1Mess!==''?'desinerInWorksname flex designerBox_input':'desinerInWorksname flex'" ref="work1Ref" style="margin-bottom: 20px">
									<i class="mandatory">*</i>
									<p>作品名称</p>
									<div>
										<el-input v-model="work1" placeholder="请填写作品名称"  @keyup.native="onChangework1(work1)"></el-input>
										<!-- <input @keyup.native="onMess1(form.address)" type="text" v-model="work1" placeholder="请填写作品名称" /> -->
										<div class="messagesP" style="margin:5px 0;padding: 0;">{{work1Mess}}</div>
									</div>
								</div>
								<!-- <p class="desinerInWorksnamec">
                                支持STEP、STL、IGES、OBJ、zip、rar格式、RGB模式、不超过10M
                              </p> -->
							</div>
							<div class="desinerInWorksbox">
								<div class="upload-demoss">
									<div class="upload-demobox">
										<div v-if="imgShow">
											<div class="demoboxAdd">
												<el-upload action="/service-center/upload/file/single"
													:on-success="handleSuccess2" class="hiddenInput" :headers="headers"
													:before-upload="beforeAvatarUpload" accept=".jpg,.jpeg,.png"
													:show-file-list="false">
													<img v-if="!img2" height="215" width="320" :src="workImg" alt="" />
													<img v-if="img2" height="215" width="320" :src="img2" alt="" />
												</el-upload>
											</div>
										</div>
									</div>
								</div>
								<div :class="work2Mess!==''?'desinerInWorksname flex designerBox_input':'desinerInWorksname flex'" ref="work2Ref" style="margin-bottom: 20px">
<!--									<i class="mandatory">*</i>-->
									<p>作品名称</p>
									<div>
										<el-input v-model="work2" placeholder="请填写作品名称"  @keyup.native="onChangework2(work2)"></el-input>
										<!-- <input type="text" v-model="work2" placeholder="请填写作品名称" /> -->
										<div class="messagesP" style="margin:5px 0;padding: 0;">{{work2Mess}}</div>
									</div>
								</div>
								<!-- <p class="desinerInWorksnamec">
                                支持STEP、STL、IGES、OBJ、zip、rar格式、RGB模式、不超过10M
                              </p> -->
							</div>
							<div class="desinerInWorksbox">
								<div class="upload-demoss">
									<div class="upload-demobox">
										<div v-if="imgShow">
											<div class="demoboxAdd">
												<el-upload action="/service-center/upload/file/single"
													:on-success="handleSuccess3" class="hiddenInput" :headers="headers"
													:before-upload="beforeAvatarUpload" accept=".jpg,.jpeg,.png"
													:show-file-list="false">
													<img v-if="!img3" height="215" width="320" :src="workImg" alt="" />
													<img v-if="img3" height="215" width="320" :src="img3" alt="" />
												</el-upload>
											</div>
										</div>
									</div>
								</div>
								<div :class="work3Mess!==''?'desinerInWorksname flex designerBox_input':'desinerInWorksname flex'" ref="work3Ref" style="margin-bottom: 20px">
<!--									<i class="mandatory">*</i>-->
									<p>作品名称</p>
									<div>
										<el-input v-model="work3" placeholder="请填写作品名称"  @keyup.native="onChangework3(work3)"></el-input>
										<!-- <input type="text" v-model="work3" placeholder="请填写作品名称" /> -->
										<div class="messagesP" style="margin:5px 0;padding: 0;">{{work3Mess}}</div>
									</div>
								</div>
								<!-- <p class="desinerInWorksnamec">
                                支持STEP、STL、IGES、OBJ、zip、rar格式、RGB模式、不超过10M
                              </p> -->
							</div>
						</div>
					</div>
					<!-- 建模师作品 -->
					<div class="desinerInWorks" v-show="classShows2">
						<h4>设计师模型上传</h4>
						<div style="
                display: flex;
                justify-content: space-between;
              ">
							<div class="desinerInWorksbox">
								<div class="upload-demoss">
									<div class="upload-demobox">
										<div v-if="imgShow">
											<div class="demoboxAdd">
												<el-upload action="/service-center/upload/file/single"
													:on-success="handleSuccess4" class="hiddenInput" :headers="headers"
													:before-upload="beforeModelUpload" accept=".jpg,.jpeg,.png"
													:show-file-list="false">
													<img v-if="!img4" height="215" width="320" :src="modelImg" alt="" />
													<img v-if="img4" height="215" width="320" :src="img4" alt="" />
												</el-upload>
												<div class="el-upload__tip desinerInWorksnamec">请上传长:230px,宽:143px或长:230px,宽:373px的图片</div>
											</div>
										</div>
									</div>
								</div>
								<div :class="model1Mess!==''?'desinerInWorksname flex designerBox_input':'desinerInWorksname flex'" ref="model1Ref" style="margin-bottom: 20px">
									<i class="mandatory">*</i>
									<p>模型名称</p>
									<div>
										<el-input v-model="model1" placeholder="请填写模型名称"  @keyup.native="onChangemodel1(model1)"></el-input>
										<!-- <input type="text" v-model="model1" placeholder="请填写模型名称" /> -->
										<div class="messagesP" style="margin:5px 0;padding: 0;">{{model1Mess}}</div>
									</div>
								</div>
								<div class="desinerInWorksname flex" style="align-items: flex-start">
									<i class="mandatory" style="margin-top: 13px">*</i>
									<p style="margin-top: 13px">模型文件</p>
									<!-- <button>模型上传</button> -->
									<el-upload class="upload-demo" action="/service-center/upload/file/single"
										:on-remove="handleRemove1" :before-remove="beforeRemove1"
										:on-success="handleSuccess7" :headers="headers"
										:before-upload="beforeModelUpload0" accept=".stl,.obj,.STL,.OBJ,"
										:file-list="fileList7">
										<el-button type="primary">模型上传</el-button>
										<div slot="tip" class="el-upload__tip desinerInWorksnamec">
											支持STL、OBJ格式，建议上传STL，预览效果更佳。
										</div>
									</el-upload>
								</div>
								<!-- <p class="desinerInWorksnamec">
                                支持STEP、STL、IGES、OBJ、zip、rar格式、RGB模式、不超过10M
                              </p> -->
							</div>
							<div class="desinerInWorksbox">
								<div class="upload-demoss">
									<div class="upload-demobox">
										<div v-if="imgShow">
											<div class="demoboxAdd">
												<el-upload action="/service-center/upload/file/single"
													:on-success="handleSuccess5" class="hiddenInput" :headers="headers"
													:before-upload="beforeModelUpload" accept=".jpg,.jpeg,.png"
													:show-file-list="false">
													<img v-if="!img5" height="215" width="320" :src="modelImg" alt="" />
													<img v-if="img5" height="215" width="320" :src="img5" alt="" />
												</el-upload>
												<div class="el-upload__tip desinerInWorksnamec">请上传长:230px,宽:143px或长:230px,宽:373px的图片</div>
											</div>
										</div>
									</div>
								</div>
								<div :class="model2Mess!==''?'desinerInWorksname flex designerBox_input':'desinerInWorksname flex'" ref="model2Ref" style="margin-bottom: 20px">
<!--									<i class="mandatory">*</i>-->
									<p>模型名称</p>
									<div>
										<el-input v-model="model2" placeholder="请填写模型名称"  @keyup.native="onChangemodel2(model2)"></el-input>
										<!-- <input type="text" v-model="model2" placeholder="请填写模型名称" /> -->
										<div class="messagesP" style="margin:5px 0;padding: 0;">{{model2Mess}}</div>
									</div>
								</div>
								<div class="desinerInWorksname flex" style="align-items: flex-start">
<!--									<i class="mandatory" style="margin-top: 13px">*</i>-->
									<p style="margin-top: 13px">模型文件</p>
									<!-- <button>模型上传</button> -->
									<el-upload class="upload-demo" action="/service-center/upload/file/single"
										:on-success="handleSuccess8" :on-remove="handleRemove2"
										:before-remove="beforeRemove2" :headers="headers"
										:before-upload="beforeModelUpload1" accept=".stl,.obj,.STL,.OBJ,"
										:file-list="fileList8">
										<el-button type="primary">模型上传</el-button>
										<div slot="tip" class="el-upload__tip desinerInWorksnamec">
											支持STL、OBJ格式，建议上传STL，预览效果更佳。
										</div>
									</el-upload>
								</div>
								<!-- <p class="desinerInWorksnamec">
                                支持STEP、STL、IGES、OBJ、zip、rar格式、RGB模式、不超过10M
                              </p> -->
							</div>
							<div class="desinerInWorksbox">
								<div class="upload-demoss">
									<div class="upload-demobox">
										<div v-if="imgShow">
											<div class="demoboxAdd">
												<el-upload action="/service-center/upload/file/single"
													:on-success="handleSuccess6" class="hiddenInput" :headers="headers"
													:before-upload="beforeModelUpload" accept=".jpg,.jpeg,.png"
													:show-file-list="false">
													<img v-if="!img6" height="215" width="320" :src="modelImg" alt="" />
													<img v-if="img6" height="215" width="320" :src="img6" alt="" />
												</el-upload>
												<div class="el-upload__tip desinerInWorksnamec">请上传长:230px,宽:143px或长:230px,宽:373px的图片</div>
											</div>
										</div>
									</div>
								</div>
								<div :class="model3Mess!==''?'desinerInWorksname flex designerBox_input':'desinerInWorksname flex'" ref="model3Ref" style="margin-bottom: 20px">
<!--									<i class="mandatory">*</i>-->
									<p>模型名称</p>
									<div>
										<el-input v-model="model3" placeholder="请填写模型名称"  @keyup.native="onChangemodel3(model3)"></el-input>
										<!-- <input type="text" v-model="model3" placeholder="请填写模型名称" /> -->
										<div class="messagesP" style="margin:5px 0;padding: 0;">{{model3Mess}}</div>
									</div>
								</div>
								<div class="desinerInWorksname flex" style="align-items: flex-start">
<!--									<i class="mandatory" style="margin-top: 13px">*</i>-->
									<p style="margin-top: 13px">模型文件</p>
									<!-- <button>模型上传</button> -->
									<el-upload class="upload-demo" action="/service-center/upload/file/single"
										:on-success="handleSuccess9" :on-remove="handleRemove3"
										:before-remove="beforeRemove3" :headers="headers" :file-list="fileList9"
										:before-upload="beforeModelUpload2" accept=".stl,.obj,.STL,.OBJ,">
										<el-button type="primary">模型上传</el-button>
										<div slot="tip" class="el-upload__tip desinerInWorksnamec">
											支持STL、OBJ格式，建议上传STL，预览效果更佳。
										</div>
									</el-upload>
								</div>
								<!-- <p class="desinerInWorksnamec">
                                支持STEP、STL、IGES、OBJ、zip、rar格式、RGB模式、不超过10M
                              </p> -->
							</div>
						</div>
					</div>
					<div style="margin-top: 20px">
						<el-checkbox v-model="agreen">
							<span style="color:#0089ff">我已阅读并同意</span>
							<span style="color:#0089ff" @click="dialogVisible1 = true">《设计师入驻协议》</span>
							<span style="color:#0089ff" @click="dialogVisible2 = true">《平台交易规则》</span>
							</el-checkbox>
					</div>

					<div class="successButtonBox">
						<el-button class="successButton" @click="getSubmit">提交</el-button>
					</div>
				</div>
				<!--认证状态-->
				<div style="width: 100%;" v-else>
					<div  class="certificationStatus">
					<!-- 待审核状态 -->
					<img v-if="cerStatus === 'AUDIT'" src="@/assets/auditIng.png" alt="" />
					<div class="name" v-if="cerStatus === 'AUDIT'">设计师认证审核中</div>
					<div class="message" v-if="cerStatus === 'AUDIT'">
						请耐心等待审核结果（最长<span>3个工作日</span>）内完成审核
					</div>
					<!-- 审核通过状态 -->
					<img v-if="cerStatus === 'PASS'" src="@/assets/pass.png" alt="" style="width:62px" />
					<div class="name" v-if="cerStatus === 'PASS'">您的入驻审核已通过，请继续完善信息，并完成开户申请</div>
					<div class="name" v-if="cerStatus === 'PASS'">
						<el-button @click="$router.push('/')" style="margin-top:20px">回首页</el-button>
						<el-button type="primary" @click="pushDesiner('openAccount')"  style="margin-top:20px">开户申请</el-button>
						<el-button type="primary" @click="pushDesiner('myself')" style="margin-top:20px">完善个人资料
						</el-button>
						<el-button type="primary" @click="pushDesiner('works')" style="margin-top:20px">完善作品信息
						</el-button>
					</div>
					<!-- 审核拒绝状态 -->
					<img v-if="cerStatus === 'REJECT'" src="@/assets/auditError.png" alt="" />
					<div v-if="cerStatus === 'REJECT'" class="message">
						原因：{{ remark }}
					</div>
					<div class="name" v-if="cerStatus === 'REJECT'">
						<el-button type="primary" @click="againCertification" style="margin-top:20px">修改认证信息</el-button>
					</div>
					</div>
					<div class="information">
							<h5>您的入驻信息</h5>
							<div class="information_top">
								<div class="information_one_box">
									<p class="information_one_box_title">身份证：</p>
									<div class="information_img" v-if="backUrl">
										<el-image :src="backUrl" :preview-src-list="srcList">
										</el-image>
										<div class="information_img_text">
											<i class="el-icon-view"></i>
											<p>预览</p>
										</div>
									</div>
									<div class="information_img" v-if="backUrl">
										<el-image :src="frontUrl" :preview-src-list="srcList">
										</el-image>
										<div class="information_img_text">
											<i class="el-icon-view"></i>
											<p>预览</p>
										</div>
									</div>
								</div>
								<div class="information_one_box"></div>
								<div class="information_one_box">
									<p class="information_one_box_title">姓名：</p>
									<span>{{designerUserMessage.name}}</span>
								</div>
								<!-- <div class="information_one_box">
									<p class="information_one_box_title">身份证：</p>
									<div class="information_img">
										<el-image :src="backUrl" :preview-src-list="srcList">
										</el-image>
										<div class="information_img_text">
											<i class="el-icon-view"></i>
											<p>预览</p>
										</div>
									</div>
									<div class="information_img">
										<el-image :src="frontUrl" :preview-src-list="srcList">
										</el-image>
										<div class="information_img_text">
											<i class="el-icon-view"></i>
											<p>预览</p>
										</div>
									</div>
								</div> -->
								<div class="information_one_box">
									<p class="information_one_box_title">性别：</p>
									<span>{{designerUserMessage.sexCn}}</span>
								</div>
								<div class="information_one_box">
									<p class="information_one_box_title">身份证号码：</p>
									<span>{{designerUserMessage.identityNo}}</span>
								</div>
								<div class="information_one_box">
									<p class="information_one_box_title">类型：</p>
									<span>{{designerUserMessage.typeCn}}</span>
								</div>
								<div class="information_one_box">
									<p class="information_one_box_title">地区：</p>
									<span>{{value[0]}} {{value[1]}} {{value[2]}}</span>
								</div>
								<div class="information_one_box">
									<p class="information_one_box_title">详细地址：</p>
									<span>{{designerUserMessage.address}}</span>
								</div>
							</div>
							<div class="information_bottom">
								<div class="information_two_box">
									<p class="information_two_box_title">个人简介：</p>
									<span>{{designerUserMessage.introduction}}</span>
								</div>
								<div style="display: flex;">
								<div class="information_two_box" v-if="classShows">
									<p class="information_two_box_title">平面设计作品：</p>
									<div class="information_img" style="width: 80px;height: 50px;" v-if="img1">
										<el-image :src="img1" :preview-src-list="srcList2">
										</el-image>
										<div class="information_img_text">
											<i class="el-icon-view"></i>
											<p>预览</p>
										</div>
									</div>
									<div class="information_img" style="width: 80px;height: 50px;" v-if="img2">
										<el-image :src="img2" :preview-src-list="srcList2">
										</el-image>
										<div class="information_img_text">
											<i class="el-icon-view"></i>
											<p>预览</p>
										</div>
									</div>
									<div class="information_img" style="width: 80px;height: 50px;" v-if="img3">
										<el-image :src="img3" :preview-src-list="srcList2">
										</el-image>
										<div class="information_img_text">
											<i class="el-icon-view"></i>
											<p>预览</p>
										</div>
									</div>
								</div>
								<div class="information_two_box" v-if="classShows2">
									<p class="information_two_box_title">模型设计作品：</p>
									<div class="information_img" v-if="img4">
										<img :src="img4" alt="" @click="getModel(fileList7[0])">
										<div class="information_img_text">
											<i class="el-icon-view"></i>
											<p>预览</p>
										</div>
									</div>
									<div class="information_img" v-if="img5">
										<img :src="img5" alt="" @click="getModel(fileList8[0])">
										<div class="information_img_text">
											<i class="el-icon-view"></i>
											<p>预览</p>
										</div>
									</div>
									<div class="information_img" v-if="img6">
										<img :src="img6" alt="" @click="getModel(fileList9[0])">
										<div class="information_img_text">
											<i class="el-icon-view"></i>
											<p>预览</p>
										</div>
									</div>
								</div>
								</div>
							</div>
					
					
					
						</div>
					
				</div>
			</div>
		</div>
		<!-- 协议 -->
		<el-dialog title="入驻协议" center :visible.sync="dialogVisible1" width="900px">
			<el-scrollbar style="height: 600px" class="crollba">
				<div v-html="content" class="vHtmlMess"></div>
			</el-scrollbar>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="agree">同意入驻协议</el-button>
			</span>
		</el-dialog>
		<el-dialog title="平台交易规则" center :visible.sync="dialogVisible2" width="900px">
			<el-scrollbar style="height: 600px" class="crollba">
				<div v-html="content1" class="tableDialog vHtmlMess" ></div>
			</el-scrollbar>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="agree">同意平台交易规则</el-button>
			</span>
		</el-dialog>
		<!-- 3D预览 -->
		<three-d ref="threeBox" :fileListNew="fileListNew" :innerVisible="innerVisibleModel" @closeDlog="closeDlog">
		</three-d>
	</div>
</template>

<script>
	import {
		getCredentials,
		getIdCardInformation,
		getDictionaryItem,
		addDesigner,
		getNewcurrent,
		designerByUserId,
		couldIn,
		getInfoByWordNo
	} from "../../utils/interface";
	import {
		mapState,
		mapMutations
	} from "vuex";

	import provinceData from "../../utils/provinceData";
	import threeD from "../threeD/index";


	export default {
		//   设计师认证
		name: "designerIn",
		components: {
			provinceData,
			threeD
		},
		data() {
			return {
				innerVisibleModel: false,
				fileListNew: [],
				designerUserMessage: {},
				content: "",
				dialogVisible1: false,
				dialogVisible2:false,
				content1: "",
				headers: {
					Authorization: "Bearer " + this.$cookies.get("api_access_token"), //	可以是授权凭证用的参数值
				},
				activeTop: 0,
				remark: "",
				cerStatus: "",
				img1: null,
				img2: null,
				img3: null,
				img4: null,
				img5: null,
				img6: null,
				work1: null,
				work2: null,
				work3: null,
				model1: null,
				model2: null,
				model3: null,
				dialogVisible: false,
				dialogImageUrl1: null,
				dialogImageUrl2: null,
				dialogImageUrl3: null,
				dialogImageUrl4: null,
				dialogImageUrl5: null,
				dialogImageUrl6: null,
				fileList1: [],
				fileList2: [],
				fileList3: [],
				fileList4: [],
				fileList5: [],
				fileList6: [],
				fileList7: [],
				fileList8: [],
				fileList9: [],
				loading: true,
				active: 0,
				// 认证状态
				status: "",
				uuid: "",
				goodat: [],
				setIn: null, // 定时器
				genderList: [{
						gender: "男",
					},
					{
						gender: "女",
					},
				],
				genderIndex: 0,
				// 上传身份证
				userInfo: {
					avatar: require("../../assets/idCarP.png"),
				},
				userInfo2: {
					avatar: require("../../assets/idCarC.png"),
				},
				workImg: require("../../assets/work.png"),
				modelImg: require("../../assets/model.png"),
				backUrl: "",
				frontUrl: "",
				// 姓名
				name: "",
				// 身份证号
				cardNumValue: "",
				// 地区选择
				value: [],
				options: provinceData,
				avatar: "",
				imgShow: true,
				fileList: [],
				screenList: [{
						name: "全部",
						// screenTwo: [],
					},
					{
						name: "",
						// screenTwo: [],
					},
					{
						name: "",
						// screenTwo: [],
					},
				],
				printScreenIndex: "0",
				classShow: true,
				printScreenTwoIndex: "0",
				checkList: [],
				agreen: false,
				// 作品选择
				checkAll: false,
				// checkedCities: [],
				// checkedCities2: [],
				isIndeterminate: true,
				checkedCountsleng: [],
				classShows: true,
				classShows2: true,
				form: {
					introduction: '',
					province: '',
					city: '',
					district: '',
					address: '',
					type: ''
				},
				userMessages: {},
				setIn: null, // 定时器
				nameMess: '', //姓名提示
				cardNumValueMess: '', //证件号码
				genderMess:'',//性别
				valueMess:'',//地区
				addressMess:'',//地址
				introductionMess:'',//个人介绍
				screenMess:'',//分类
				goodatMess:'',//擅长类型
				work1Mess:'',
				work2Mess:'',
				work3Mess:'',
				model1Mess:'',
				model2Mess:'',
				model3Mess:'',
				// checkedCitiesFlag: true
			};
		},
		computed: {
			...mapState({
				isTokenDoor: "isTokenDoor",
				isLogin: "isLogin",
			}),
			srcList() {
				return [this.backUrl, this.frontUrl]
			},
			srcList2() {
				return [this.img1, this.img2, this.img3]
			},
		},
		watch: {},
		mounted() {
			getNewcurrent()
				.then((res) => {
					this.userMessages = res;
				})
				.catch((err) => {
					console.log(err);
				});
		},
		created() {
			getInfoByWordNo({
				"wordNo": "ZCYPTFWXY"
			}).then((res) => {
				if (res && res.data) {
					this.content = res.data.content;
				}
			});
			getInfoByWordNo({
				"wordNo": "JYGZ"
			}).then((res) => {
				if (res && res.data) {
					this.content1 = res.data.content;
				}
			});
			
			this.setIn = setInterval(() => {
				if (this.isTokenDoor === true) {
					clearInterval(this.setIn);
					this.getUserCredentials();
					this.getUserInfo();
					this.getDictionaryItem();
					this.isDesigner();
				}
			}, 500);
		},
		methods: {
			...mapMutations(["isLoginVuex"]),
			getModel(item) {
				this.$refs.threeBox.threeAnimal(item);
				this.innerVisibleModel = true;
				// console.log('222222',this.fileList7[0].url );
			},
			closeDlog(index) {
				this.innerVisibleModel = index;
			},
			pushDesiner(info) {
				if (info == 'myself') {
					window.open(this.$url.designerWeb + '/#/storeMessage', "_blank");
				} else if (info == 'works') {
					if (this.form.type == "GRAPHIC") {
						// 平面设计师 -- 成品展示
						window.open(this.$url.designerWeb + '/#/productDisplay', "_blank");
					} else if (this.form.type == "MODEL") {
						// 模型设计师 -- 模型管理
						window.open(this.$url.designerWeb + '/#/modelManagement', "_blank");
					} else if (this.form.type == "BOTH") {
						window.open(this.$url.designerWeb + '/#/modelManagement', "_blank");
					}
				}else if(info == 'openAccount'){
					window.open(this.$url.designerWeb + '/#/accountManagement', "_blank");
				}
			},
			agree() {
				this.dialogVisible1 = false;
				this.dialogVisible2 = false;
				this.agreen = true;
			},
			onMess(str){
				if(str === ''){
					this.introductionMess = '请输入个人介绍'
				}else{
					this.introductionMess = ''
				}
			},
			onMess1(str){
				if(str === ''){
					this.addressMess = '请输入地址填写'
				}else{
					this.addressMess = ''
				}
			},
			onChangework1(str){
				if(str === ''){
					this.work1Mess = '请填写作品名称'
				}else{
					this.work1Mess = ''
				}
			},
			onChangework2(str){
				if(str === ''){
					this.work2Mess = '请填写作品名称'
				}else{
					this.work2Mess = ''
				}
			},
			onChangework3(str){
				if(str === ''){
					this.work3Mess = '请填写作品名称'
				}else{
					this.work3Mess = ''
				}
			},
			onChangemodel1(str){
				if(str === ''){
					this.model1Mess = '请填写模型名称'
				}else{
					this.model1Mess = ''
				}
			},
			onChangemodel2(str){
				if(str === ''){
					this.model2Mess = '请填写模型名称'
				}else{
					this.model2Mess = ''
				}
			},
			onChangemodel3(str){
				if(str === ''){
					this.model3Mess = '请填写模型名称'
				}else{
					this.model3Mess = ''
				}
			},
			// 地区选择
			handleChange(value) {
				// if(str === ''){
				// 	this.addressMess = '请输入地址填写'
				// }else{
				// 	this.addressMess = ''
				// }
				if(value.length > 0){
					this.valueMess=''
				}else{
					this.valueMess ='请选择地区'
				}
				if (value != null && value.length === 3) {
					this.form.province = value[0]
					this.form.city = value[1]
					this.form.district = value[2]
				} else if (value != null && value.length === 2) {
					this.form.province = value[0]
					this.form.city = value[1]
					this.form.district = value[1]
				}
			},
			getGender(i) {
				if (this.status !== "SUBMIT" && this.status !== "APPROVE") {
					this.genderIndex = i;
				}
			},
			beforeModelUpload(file) {
				
				// const isJPG = file.type.indexOf('image') !== -1;
				// const isLt2M = file.size / 1024 / 1024 < 2;
				// if (!isJPG) {
				//     this.$message.warning('上传图片只能是图片格式!');
				// }
				// if (!isLt2M) {
				//     this.$message.warning('上传图片大小不能超过 2MB!');
				// }
				// let fileTypes = [
				// 	".jpg",
				// 	".png",
				// 	".jpeg",
				// 	".bmp",
				// 	".JPG",
				// 	".PNG",
				// 	".JPEG",
				// 	".BMP",
				// ];
				// let fileName = file.name.lastIndexOf(".");
				// const fileNameLen = file.name.length;
				// const fileTypeName = file.name.substring(fileName, fileNameLen);
				// let fileIndex = fileTypes.indexOf(fileTypeName);
				// if (fileIndex === -1) {
				// 	this.$alert("只能上传图片格式", "提示", {
				// 		confirmButtonText: "确定",
				// 	});
				// }
				
				// let _this = this;
				// let imgWidth = "";
				// let imgHeight = "";
				// let width = 282;
				// let height = 201;
				// let isSize = new Promise(function (resolve, reject) {
				//     let _URL = window.URL || window.webkitURL;
				//     let img = new Image();
				//     img.onload = function () {
				//         imgWidth = img.width;
				//         imgHeight = img.height;
				//         let valid = ((img.width === 230 && img.height === 143) || (img.width === 230 && img.height === 373));
				//         valid ? resolve() : reject();
				//     };
				//     img.src = _URL.createObjectURL(file);
				// }).then(() => {
				//     return file;
				// },
				// () => {
				//     _this.$message.warning({
				//         message: '上传文件的图片大小不合符标准,宽需要为 230px，高需要为143px或宽需要为 230px，高需要为373px。当前上传图片的宽高分别为：' + imgWidth + 'px和' + imgHeight + 'px',
				//         btn: false
				//     });
				//     return Promise.reject();
				// });
				// return isJPG && isLt2M && isSize;
				// // let isLt2M = file.size / 1024 / 1024 < 100;
				// // if (!isLt2M) {
				// // 	this.$message.error("上传模型大小不能超过 100MB!");
				// // 	this.fileList7 = [];
				// // }
			},
			beforeModelUpload0(file) {
				let isLt2M = file.size / 1024 / 1024 < 100;
				if (!isLt2M) {
					this.$message.error("上传模型大小不能超过 100MB!");
					this.fileList7 = [];
				}
			},
			beforeModelUpload1(file) {
				let isLt2M = file.size / 1024 / 1024 < 100;
				if (!isLt2M) {
					this.$message.error("上传模型大小不能超过 100MB!");
					this.fileList8 = [];
				}
			},
			beforeModelUpload2(file) {
				let isLt2M = file.size / 1024 / 1024 < 100;
				if (!isLt2M) {
					this.$message.error("上传模型大小不能超过 100MB!");
					this.fileList9 = [];
				}
			},
			// 将头像显示
			handleFile(e) {
				//获取当前点击事件的target元素对其进行兼容
				let $target = e.target || e.srcElement;
				//   取第一个元素
				let file = $target.files[0];
				/**
				 * 使用FileReader对象，
				 * web应用程序可以异步的读取存储在用户计算机上的文件(或者原始数据缓冲)内容，
				 * 可以使用File对象或者Blob对象来指定所要处理的文件或数据。
				 *  */
				var reader = new FileReader(); // //读取本地文件，以gbk编码方式输出
				reader.onload = (data) => {
					//成功读取后
					// console.log(data);
					let res = data.target || data.srcElement;
					// //读取完毕后输出结果
					this.userInfo.avatar = res.result;
				};
				reader.readAsDataURL(file);
			},
			beforeAvatarUpload(file) {
				let fileTypes = [
					".jpg",
					".png",
					".jpeg",
					".bmp",
					".JPG",
					".PNG",
					".JPEG",
					".BMP",
				];
				let fileName = file.name.lastIndexOf(".");
				const fileNameLen = file.name.length;
				const fileTypeName = file.name.substring(fileName, fileNameLen);
				let fileIndex = fileTypes.indexOf(fileTypeName);
				if (fileIndex === -1) {
					this.$alert("只能上传图片格式", "提示", {
						confirmButtonText: "确定",
					});
				}
				return fileIndex !== -1;
			},
			handleAvatarSuccess(obj, fileList) {
				let data = {
					url: obj.url,
				};
				this.loading = true;
				getIdCardInformation(data)
					.then((res) => {
						if (res.success) {
							this.backUrl = obj.url;
							this.cardNumValue = res.data.cardNum;
							this.name = res.data.name;
							this.genderIndex = res.data.gender === "FEMALE" ? 1 : 0;
							this.loading = false;
						} else {
							this.$alert("认证失败，请重新上传！", "提示", {
								confirmButtonText: "确定",
							});
							this.loading = false;
						}
					})
					.catch(() => {
						this.loading = false;
					});
			},
			handleAvatarSuccess2(obj, fileList) {
				this.frontUrl = obj.url;
			},
			getUserInfo() {
				getNewcurrent()
					.then((res) => {
						this.form.iconUrl = res.headUrl ? res.headUrl : "";
					})
					.catch((err) => {})
			},
			// 重新认证
			againCertification() {
				this.activeTop = 1
			},
			// 根据用户获取认证信息
			getUserCredentials() {
				this.form = {
					province: '',
					city: '',
					district: '',
					address: ''
				}
				if (this.isLogin) {
					// this.uuid = localStorage.getItem("uuid");
					this.uuid = this.$store.state.isUsermessage.uuid
					let data = {
						userUuid: this.uuid,
					};
					this.loading = true;
					if (this.uuid) {
						console.log("this.uuid:" + this.uuid);
						getCredentials(data).then((res) => {
							this.reset()
								if (res.success) {
									this.status = res.data.status;
									this.uuid = res.data.userUuid;
									this.backUrl = res.data.backUrl;
									this.cardNumValue = res.data.cardNum;
									this.frontUrl = res.data.frontUrl;
									this.name = res.data.name;
									this.genderIndex = res.data.gender === "FEMALE" ? 1 : 0;
									if (this.status === "SUBMIT") {
										this.active = 1;
										this.loading = false;
									} else {
										this.active = 2;
										this.loading = false;
									}

									if (res.data.status !== "REJECT" && res.data.identityType === "ENTERPRISE") {
										this.$message({
											type: "success",
											message: "当前用户为企业用户，无法进行设计师认证！",
										});
										this.$router.push("/design");
										this.loading = false;
									} else {
										console.log("this.uuid2:" + this.uuid);
										designerByUserId(this.uuid).then((res) => {
											if (res != null && res !== "") {
												if (res.status === "PASS") {
													this.activeTop = 3;
													this.loading = false;
													// this.$message({
													//   type: "success",
													//   message: "当前用户已入驻成功，无需再次入驻",
													// });
													// this.$router.push("/design");
												} else if (res.status === "AUDIT") {
													this.activeTop = 2;
													this.loading = false;
													// this.$message({
													//   type: "success",
													//   message: "当前用户设计师认证信息正在审核中",
													// });
													// this.$router.push("/design");
												}
											}
										});
									}
								} else {
									this.status = "";
									this.active = 0;
									this.uuid = "";
									this.backUrl = "";
									this.cardNumValue = "";
									this.frontUrl = "";
									this.name = "";
									this.genderIndex = 0;
									this.loading = false;
								}
							})
							.catch(() => {
								this.loading = false;
							});
					} else {
						this.status = "";
						this.active = 0;
					}
				} else {
					this.$message({
						type: "success",
						message: "您需要先登录哦！",
					});
					this.$router.push("/login");
				}
			},
			// 预览文件
			handleSuccess1(obj, fileList1) {
				// console.log(obj);
				this.img1 = obj.url;
				this.fileList1 = [];
				this.fileList1.push({
					fileName: obj.name,
					fileUrl: obj.url,
				})
			},
			handleSuccess2(obj, fileList2) {
				// console.log(obj);
				this.img2 = obj.url;
				this.fileList2 = [];
				this.fileList2.push({
					fileName: obj.name,
					fileUrl: obj.url,
				});
			},
			handleSuccess3(obj, fileList3) {
				// console.log(obj);
				this.img3 = obj.url;
				this.fileList3 = [];
				this.fileList3.push({
					fileName: obj.name,
					fileUrl: obj.url,
				});
			},
			handleSuccess4(obj, fileList4) {
				// console.log(obj);
				this.img4 = obj.url;
				this.fileList4 = [];
				this.fileList4.push({
					fileName: obj.name,
					fileUrl: obj.url,
				});
			},
			handleSuccess5(obj, fileList5) {
				// console.log(obj);
				this.img5 = obj.url;
				this.fileList5 = [];
				this.fileList5.push({
					fileName: obj.name,
					fileUrl: obj.url,
				});
			},
			handleSuccess6(obj, fileList6) {
				// console.log(obj);
				this.img6 = obj.url;
				this.fileList6 = [];
				this.fileList6.push({
					fileName: obj.name,
					fileUrl: obj.url,
				});
			},
			// 模型上传
			handleRemove1(file, fileList) {
				this.fileList7 = fileList
				// console.log(file, fileList);
			},
			handleRemove2(file, fileList) {
				this.fileList8 = fileList
				// console.log(file, fileList);
			},
			handleRemove3(file, fileList) {
				this.fileList9 = fileList
				// console.log(file, fileList);
			},
			handlePreview(file) {
				// console.log(file);
			},
			handleSuccess7(obj, fileList) {
				this.fileList7 = [];
				this.fileList7.push(obj);
			},
			handleSuccess8(obj, fileList) {
				// console.log(obj);
				this.fileList8 = [];
				this.fileList8.push(obj);
			},
			handleSuccess9(obj, fileList) {
				// console.log(obj);
				this.fileList9 = [];
				this.fileList9.push(obj);
			},
			handleExceed(files, fileList) {
				this.$message.warning(
					`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
                    files.length + fileList.length
                        } 个文件`
				);
			},
			beforeRemove1(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`).then(() => {
					this.fileList7 = [];
				});
			},
			beforeRemove2(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`).then(() => {
					this.fileList8 = [];
				});
			},
			beforeRemove3(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`).then(() => {
					this.fileList9 = [];
				});
			},
			getPrintScreen(i) {
				// this.checkedCities = [];
				if (this.printScreenIndex == i) {
					this.classShow = !this.classShow;
					this.screenMess = ''
				} else {
					this.classShow = true;
					this.screenMess = ''
				}
				this.printScreenIndex = i;
				if (i == 0) {
					this.form.type = "BOTH";
					this.classShows = true;
					this.classShows2 = true;
				} else if (i == 1) {
					this.form.type = "MODEL";
					this.classShows = false;
					this.classShows2 = true
				} else if (i == 2) {
					this.form.type = "GRAPHIC";
					this.classShows = true;
					this.classShows2 = false
				}
			},
			getPrintScreenTwo(i) {
				this.printScreenTwoIndex = i;
			},
			// 设计选项
			// handleCheckAllChange(val) {
			//     this.checkedCities = val? this.screenList[this.printScreenIndex].screenTwo: [];
			//     this.isIndeterminate = false;
			//     this.classShows = true;
			//     this.classShows2 = true;
			//     // console.log(this.checkedCities);
			//     if (this.checkedCities.length > 0) {
			//         let cates = [];
			//         let re1 = 0;
			//         let re2 = 0;
			//         this.checkedCities.forEach((item, index) => {
			//             if (item.groupId == "4028e8a47d1339d0017d17d15cfe0005") {
			//                 //平面设计
			//                 re1++;
			//             }
			//             if (item.groupId == "4028e8a47d1339d0017d17d1d2020006") {
			//                 //建模设计师
			//                 re2++;
			//             }
			//         });
			//         // console.log(re1 + "----------------------" + re2);
			//         if (re1 > 0 && re2 > 0) {
			//             this.classShows = true;
			//             this.classShows2 = true;
			//         } else if (re1 > 0 && re2 == 0) {
			//             this.classShows = true;
			//             this.classShows2 = false;
			//         } else if (re1 == 0 && re2 >= 0) {
			//             this.classShows = false;
			//             this.classShows2 = true;
			//         }
			//     }
			// },
			// handleCheckedCitiesChange(value) {
			//     this.checkedCountsleng = value;
			//     let checkedCount = this.checkedCountsleng.length;
			//     this.checkAll =
			//         checkedCount ===
			//         this.screenList[this.printScreenIndex].screenTwo.length;
			//     this.isIndeterminate =
			//         checkedCount > 0 &&
			//         checkedCount < this.screenList[this.printScreenIndex].screenTwo.length;
			//     let re1 = 0;
			//     let re2 = 0;
			//     // console.log("----------------------" + JSON.stringify(value));
			//     value.forEach((item, index) => {
			//         if (item.groupId == "4028e8a47d1339d0017d17d15cfe0005") {
			//             //平面设计
			//             re1++;
			//         }
			//         if (item.groupId == "4028e8a47d1339d0017d17d1d2020006") {
			//             //建模设计师
			//             re2++;
			//         }
			//     });
			//     if (re1 > 0 && re2 > 0) {
			//         this.classShows = true;
			//         this.classShows2 = true;
			//     } else if (re1 > 0 && re2 == 0) {
			//         this.classShows = true;
			//         this.classShows2 = false;
			//     } else if (re1 == 0 && re2 >= 0) {
			//         this.classShows = false;
			//         this.classShows2 = true;
			//     }
			// },
			handleCheckedListChange(value) {
				// console.log("----------------------" + JSON.stringify(this.checkList));
				
				if(value.length >0){
					this.goodatMess =''
				}else{
					this.goodatMess = '请选择擅长类型'
				}
				console.log(value.length > 0,this.checkList)
				let resource = [];
				value.forEach((item, index) => {
					let obj = this.goodat.find((item1) => item1.id === item);
					resource.push({
						goodatUuid: item,
						goodatName: obj.button
					});
				});
				this.form.designerGoodatList = resource;
			},
			//重置校验提示
			reset(){
				this.nameMess='' //姓名提示
				this.cardNumValueMess= ''//证件号码
				this.genderMess=''//性别
				this.valueMess=''//地区
				this.addressMess=''//地址
				this.introductionMess=''//个人介绍
				this.screenMess=''//分类
				this.goodatMess=''//擅长类型
				this.work1Mess=''
				this.work2Mess=''
				this.work3Mess=''
				this.model1Mess=''
				this.model2Mess=''
				this.model3Mess=''
			},
			// 获取字典值
			getDictionaryItem() {
				let resource = [];
				getDictionaryItem({
					groupCode: "graphic_designer"
				}).then((res) => {
					// let re = [];
					if (res != null && res.length > 0) {
						this.screenList[2].name = res[0].groupName;
						// res.forEach((item, index) => {
						//     re.push({names: item.name, id: item.code, groupId: item.groupUuid});
						//     resource.push({
						//         names: item.name,
						//         id: item.code,
						//         groupId: item.groupUuid,
						//     });
						// });
						// this.screenList[2].screenTwo = re;
					}
					getDictionaryItem({
						groupCode: "model_designer"
					}).then((res1) => {
						// let re = [];
						if (res1 != null && res1.length > 0) {
							this.screenList[1].name = res1[0].groupName;
							// res1.forEach((item, index) => {
							//     re.push({names: item.name, id: item.code, groupId: item.groupUuid});
							//     resource.push({
							//         names: item.name,
							//         id: item.code,
							//         groupId: item.groupUuid,
							//     });
							// });
							// this.screenList[1].screenTwo = re;
						}
					});
				});

				// this.screenList[0].screenTwo = resource;
				getDictionaryItem({
					groupCode: "designer_goodat"
				}).then((res) => {
					let re = [];
					res.forEach((item, index) => {
						re.push({
							button: item.name,
							id: item.code
						});
					});
					this.goodat = re;
				});
			},
			// 提交入驻信息
			getSubmit() {
				this.fileList = []
				
				// if (this.name && this.cardNumValue && this.value.length > 0
				//     && this.form.address && this.form.introduction 
				//     && this.classShows && this.img1 && this.img2 && this.img3 && this.agreen 
				//      && this.work1 && this.work2 && this.work3 && this.classShows2 && this.fileList9.length >0
				//     && this.img4 && this.img5 && this.img6 && this.fileList7.length>0 && this.fileList8.length>0
				//     && this.model1 && this.model2 && this.model3) {
				//    debugger;
				// 	return true
				  
				// } else {
					
					// if (!this.name) {
					// 	this.nameMess = '请输入姓名'
					// 	document.documentElement.scrollTop = this.$refs['nameRef'].offsetTop
					// }else{
					// 	this.nameMess = ''
					// }
					
					// if(!this.cardNumValue){
					// 	this.cardNumValueMess = '请输入正确的证件号码'
					// 	document.documentElement.scrollTop = this.$refs['cardNumValueRef'].offsetTop
					// }else{
					// 	this.cardNumValueMess = ''
					// }
					
					if(this.value.length == 0){
						this.valueMess = '请选择地区'
						document.documentElement.scrollTop = this.$refs['valueRef'].offsetTop
					}else{
						this.valueMess =''
					}
					
					// if(this.genderList){
					// 	this.genderMess = '请选择性别'
					// 	document.documentElement.scrollTop = this.$refs['genderRef'].offsetTop
					// }else{
					// 	this.genderMess =''
					// }
					
					if(!this.form.address){
						this.addressMess ='请输入地址填写'
						document.documentElement.scrollTop = this.$refs['addressRef'].offsetTop
						return;
					}else{
						this.addressMess =''
					}
					
					if(!this.form.introduction){
						this.introductionMess ='请输入个人介绍'
						document.documentElement.scrollTop = this.$refs['introductionRef'].offsetTop
						return;
					}else{
						this.introductionMess =''
					}
					
					
					if(this.checkList.length == 0){
						this.goodatMess ='请选择擅长类型'
						document.documentElement.scrollTop = this.$refs['goodatRef'].offsetTop
						return;
					}else{
						this.goodatMess =''
					}
					
					if(this.classShows){
					
					if(!this.work1){
						this.work1Mess ='请填写作品名称'
						document.documentElement.scrollTop = this.$refs['work1Ref'].offsetTop
						return;
					}else{
						this.work1Mess =''
					}
					
					// if(!this.work2){
					// 	this.work2Mess ='请填写作品名称'
					// 	document.documentElement.scrollTop = this.$refs['work2Ref'].offsetTop
					// 	return;
					// }else{
					// 	this.work2Mess =''
					// }
					
					// if(!this.work3){
					// 	this.work3Mess ='请填写作品名称'
					// 	document.documentElement.scrollTop = this.$refs['work3Ref'].offsetTop
					// 	return;
					// }else{
					// 	this.work3Mess =''
					// }
					if(!this.img1){
						// this.work1Mess ='请上传作品图片1'
						document.documentElement.scrollTop = this.$refs['work1Ref'].offsetTop
						return;
					}
          // else if(!this.img2){
					// 	// this.work2Mess ='请上传作品图片2'
					// 	document.documentElement.scrollTop = this.$refs['work2Ref'].offsetTop
					// 	return;
					// }else if(!this.img3){
					// 	// this.work3Mess ='请上传作品图片3'
					// 	document.documentElement.scrollTop = this.$refs['work3Ref'].offsetTop
					// 	return;
					// }
					
					}
					
					
					if(this.classShows2){
					
					if(!this.model1){
						this.model1Mess ='请填写模型名称'
						document.documentElement.scrollTop = this.$refs['model1Ref'].offsetTop
						return;
					}else{
						this.model1Mess =''
					}
					
					// if(!this.model2){
					// 	this.model2Mess ='请填写模型名称'
					// 	document.documentElement.scrollTop = this.$refs['model2Ref'].offsetTop
					// 	return;
					// }else{
					// 	this.model2Mess =''
					// }
					//
					// if(!this.model3){
					// 	this.model3Mess ='请填写模型名称'
					// 	document.documentElement.scrollTop = this.$refs['model3Ref'].offsetTop
					// 	return;
					// }else{
					// 	this.model3Mess =''
					// }
					
					if(!this.img4){
						// this.model1Mess ='请上传模型缩略图1'
						document.documentElement.scrollTop = this.$refs['model1Ref'].offsetTop
						return;
					}
          // else if(!this.img5){
					// 	// this.model2Mess ='请上传模型缩略图2'
					// 	document.documentElement.scrollTop = this.$refs['model2Ref'].offsetTop
					// 	return;
					// }else if(!this.img6){
					// 	// this.model3Mess ='请上传模型缩略图3'
					// 	document.documentElement.scrollTop = this.$refs['model3Ref'].offsetTop
					// 	return;
					// }
					}
				// }
				
				// 信息认证
				// if (!this.name) {
				// 	this.$alert("请填写认证姓名", "提示", {
				// 		confirmButtonText: "确定",
				// 	});
				// 	return;
				// } else if (!this.cardNumValue) {
				// 	this.$alert("请填写证件号码", "提示", {
				// 		confirmButtonText: "确定",
				// 	});
				// 	return;
				// } else
        if (this.value.length == 0) {
					this.$alert("请填写认证地区", "提示", {
						confirmButtonText: "确定",
					});
					return;
				} else if (!this.form.address) {
					this.$alert("请填写详细地址", "提示", {
						confirmButtonText: "确定",
					});
					return;
				}
          // else if (!this.form.introduction) {
				// 	this.$alert("请填写个人介绍", "提示", {
				// 		confirmButtonText: "确定",
				// 	});
				// 	return;
				// 	// } else if (!this.checkAll && this.checkedCities.length == 0) {
				// 	//     this.$alert("请选择分类", "提示", {
				// 	//         confirmButtonText: "确定",
				// 	//     });
				// 	//     return;
				// } else if (this.checkList.length == 0) {
				// 	this.$alert("请选择擅长的类型", "提示", {
				// 		confirmButtonText: "确定",
				// 	});
				// 	return;
				// }
				// if (this.classShows) {
				// 	if (!this.img1) {
				// 		this.$alert("请上传作品图片1", "提示", {
				// 			confirmButtonText: "确定",
				// 		});
				// 		return;
				// 	} else if (!this.img2) {
				// 		this.$alert("请上传作品图片2", "提示", {
				// 			confirmButtonText: "确定",
				// 		});
				// 		return;
				// 	} else if (!this.img3) {
				// 		this.$alert("请上传作品图片3", "提示", {
				// 			confirmButtonText: "确定",
				// 		});
				// 		return;
				// 	} else if (!this.work1) {
				// 		this.$alert("请填写作品名称1", "提示", {
				// 			confirmButtonText: "确定",
				// 		});
				// 		return;
				// 	} else if (!this.work2) {
				// 		this.$alert("请填写作品名称2", "提示", {
				// 			confirmButtonText: "确定",
				// 		});
				// 		return;
				// 	} else if (!this.work3) {
				// 		this.$alert("请填写作品名称3", "提示", {
				// 			confirmButtonText: "确定",
				// 		});
				// 		return;
				// 	}
				// }
				// if (this.classShows2) {
				// 	if (!this.img4) {
				// 		this.$alert("请上传模型缩略图1", "提示", {
				// 			confirmButtonText: "确定",
				// 		});
				// 		return;
				// 	} else if (!this.img5) {
				// 		this.$alert("请上传模型缩略图2", "提示", {
				// 			confirmButtonText: "确定",
				// 		});
				// 		return;
				// 	} else if (!this.img6) {
				// 		this.$alert("请上传模型缩略图3", "提示", {
				// 			confirmButtonText: "确定",
				// 		});
				// 		return;
				// 	} else if (!this.model1) {
				// 		this.$alert("请填写模型名称1", "提示", {
				// 			confirmButtonText: "确定",
				// 		});
				// 		return;
				// 	} else if (!this.model2) {
				// 		this.$alert("请填写模型名称2", "提示", {
				// 			confirmButtonText: "确定",
				// 		});
				// 		return;
				// 	} else if (!this.model3) {
				// 		this.$alert("请填写模型名称3", "提示", {
				// 			confirmButtonText: "确定",
				// 		});
				// 		return;
				// 	} else if (
				// 		this.model1 == this.model2 ||
				// 		this.model1 == this.model3 ||
				// 		this.model2 == this.model3
				// 	) {
				// 		this.$alert("模型名称不可重复", "提示", {
				// 			confirmButtonText: "确定",
				// 		});
				// 		return;
				// 	} else
        	if (this.fileList7.length == 0) {
            this.$alert("请上传模型文件1", "提示", {
              confirmButtonText: "确定",
            });
          }
				// 		return;
				// 	} else if (this.fileList8 == 0) {
				// 		this.$alert("请上传模型文件2", "提示", {
				// 			confirmButtonText: "确定",
				// 		});
				// 		return;
				// 	} else if (this.fileList9 == 0) {
				// 		this.$alert("请上传模型文件3", "提示", {
				// 			confirmButtonText: "确定",
				// 		});
				// 		return;
				// 	}
				// }
				// if (!this.agreen) {
				// 	this.$alert("请勾选同意入驻协议", "提示", {
				// 		confirmButtonText: "确定",
				// 	});
				// 	return;
				// }
				
				
				if (this.form.type == undefined) {
					this.form.type = 'BOTH';
				}
				this.form.name = this.name;
				this.form.nickname = this.name;
				this.form.identityNo = this.cardNumValue;
				this.form.frontIdentityUrl = this.frontUrl;
				this.form.backIdentityUrl = this.backUrl;
				// this.form.designerCateList = []
				// this.checkedCities.map(item=>{
				//     this.form.designerCateList.push({
				//         categoryUuid: item.id,
				//         categoryName: item.names,
				//         groupId: item.groupId
				//     })
				// })
				if (this.genderIndex == 0) {
					this.form.sex = "MALE";
				} else if (this.genderIndex == 1) {
					this.form.sex = "FEMALE";
				}
				if (this.form.type === 'BOTH') {
					if (this.fileList1.length > 0 && this.work1 != null) {
						let obj = this.fileList1[0];
						this.fileList.push({
							attachmentType: "GRAPHIC",
							fileName: obj.fileName,
							fileUrl: obj.fileUrl,
							workName: this.work1,
							workOrder: 1
						});
					}
					if (this.fileList2.length > 0 && this.work2 != null) {
						let obj = this.fileList2[0];
						this.fileList.push({
							attachmentType: "GRAPHIC",
							fileName: obj.fileName,
							fileUrl: obj.fileUrl,
							workName: this.work2,
							workOrder: 2
						});
					}
					if (this.fileList3.length > 0 && this.work3 != null) {
						let obj = this.fileList3[0];
						this.fileList.push({
							attachmentType: "GRAPHIC",
							fileName: obj.fileName,
							fileUrl: obj.fileUrl,
							workName: this.work3,
							workOrder: 3
						});
					}
					if (this.fileList4.length > 0 && this.model1 != null) {
						let obj = this.fileList4[0];
						this.fileList.push({
							attachmentType: "MODEL_IMAGE",
							fileName: obj.fileName,
							fileUrl: obj.fileUrl,
							workName: this.model1,
							workOrder: 4
						});
					}
					if (this.fileList5.length > 0 && this.model2 != null) {
						let obj = this.fileList5[0];
						this.fileList.push({
							attachmentType: "MODEL_IMAGE",
							fileName: obj.fileName,
							fileUrl: obj.fileUrl,
							workName: this.model2,
							workOrder: 6
						});
					}
					if (this.fileList6.length > 0 && this.model3 != null) {
						let obj = this.fileList6[0];
						this.fileList.push({
							attachmentType: "MODEL_IMAGE",
							fileName: obj.fileName,
							fileUrl: obj.fileUrl,
							workName: this.model3,
							workOrder: 8
						});
					}
					if (this.fileList7.length > 0 && this.model1 != null) {
						let obj = this.fileList7[0];
						if (obj.fileName) {
							this.fileList.push({
								attachmentType: "MODEL",
								fileName: obj.fileName,
								fileUrl: obj.fileUrl,
								workName: this.model1,
								workOrder: 5
							});
						} else {
							this.fileList.push({
								attachmentType: "MODEL",
								fileName: obj.name,
								fileUrl: obj.url,
								workName: this.model1,
								workOrder: 5
							});
						}
					}
					if (this.fileList8.length > 0 && this.model2 != null) {
						let obj = this.fileList8[0];
						if (obj.fileName) {
							this.fileList.push({
								attachmentType: "MODEL",
								fileName: obj.fileName,
								fileUrl: obj.fileUrl,
								workName: this.model2,
								workOrder: 7
							});
						} else {
							this.fileList.push({
								attachmentType: "MODEL",
								fileName: obj.name,
								fileUrl: obj.url,
								workName: this.model2,
								workOrder: 7
							});
						}
					}
					if (this.fileList9.length > 0 && this.model3 != null) {
						let obj = this.fileList9[0];
						if (obj.fileName) {
							this.fileList.push({
								attachmentType: "MODEL",
								fileName: obj.fileName,
								fileUrl: obj.fileUrl,
								workName: this.model3,
								workOrder: 9
							});
						} else {
							this.fileList.push({
								attachmentType: "MODEL",
								fileName: obj.name,
								fileUrl: obj.url,
								workName: this.model3,
								workOrder: 9
							});
						}
					}
				} else if (this.form.type === 'MODEL') {
					if (this.fileList4.length > 0 && this.model1 != null) {
						let obj = this.fileList4[0];
						this.fileList.push({
							attachmentType: "MODEL_IMAGE",
							fileName: obj.fileName,
							fileUrl: obj.fileUrl,
							workName: this.model1,
							workOrder: 4
						});
					}
					if (this.fileList5.length > 0 && this.model2 != null) {
						let obj = this.fileList5[0];
						this.fileList.push({
							attachmentType: "MODEL_IMAGE",
							fileName: obj.fileName,
							fileUrl: obj.fileUrl,
							workName: this.model2,
							workOrder: 6
						});
					}
					if (this.fileList6.length > 0 && this.model3 != null) {
						let obj = this.fileList6[0];
						this.fileList.push({
							attachmentType: "MODEL_IMAGE",
							fileName: obj.fileName,
							fileUrl: obj.fileUrl,
							workName: this.model3,
							workOrder: 8
						});
					}
					if (this.fileList7.length > 0 && this.model1 != null) {
						let obj = this.fileList7[0];
						if (obj.fileName) {
							this.fileList.push({
								attachmentType: "MODEL",
								fileName: obj.fileName,
								fileUrl: obj.fileUrl,
								workName: this.model1,
								workOrder: 5
							});
						} else {
							this.fileList.push({
								attachmentType: "MODEL",
								fileName: obj.name,
								fileUrl: obj.url,
								workName: this.model1,
								workOrder: 5
							});
						}
					}
					if (this.fileList8.length > 0 && this.model2 != null) {
						let obj = this.fileList8[0];
						if (obj.fileName) {
							this.fileList.push({
								attachmentType: "MODEL",
								fileName: obj.fileName,
								fileUrl: obj.fileUrl,
								workName: this.model2,
								workOrder: 7
							});
						} else {
							this.fileList.push({
								attachmentType: "MODEL",
								fileName: obj.name,
								fileUrl: obj.url,
								workName: this.model2,
								workOrder: 7
							});
						}
					}
					if (this.fileList9.length > 0 && this.model3 != null) {
						let obj = this.fileList9[0];
						if (obj.fileName) {
							this.fileList.push({
								attachmentType: "MODEL",
								fileName: obj.fileName,
								fileUrl: obj.fileUrl,
								workName: this.model3,
								workOrder: 9
							});
						} else {
							this.fileList.push({
								attachmentType: "MODEL",
								fileName: obj.name,
								fileUrl: obj.url,
								workName: this.model3,
								workOrder: 9
							});
						}
					}
				} else if (this.form.type === 'GRAPHIC') {
					if (this.fileList1.length > 0 && this.work1 != null) {
						let obj = this.fileList1[0];
						this.fileList.push({
							attachmentType: "GRAPHIC",
							fileName: obj.fileName,
							fileUrl: obj.fileUrl,
							workName: this.work1,
							workOrder: 1
						});
					}
					if (this.fileList2.length > 0 && this.work2 != null) {
						let obj = this.fileList2[0];
						this.fileList.push({
							attachmentType: "GRAPHIC",
							fileName: obj.fileName,
							fileUrl: obj.fileUrl,
							workName: this.work2,
							workOrder: 2
						});
					}
					if (this.fileList3.length > 0 && this.work3 != null) {
						let obj = this.fileList3[0];
						this.fileList.push({
							attachmentType: "GRAPHIC",
							fileName: obj.fileName,
							fileUrl: obj.fileUrl,
							workName: this.work3,
							workOrder: 3
						});
					}
				}
				this.form.designerAttachmentList = this.fileList;
				let parmars = this.form;
				addDesigner(parmars).then((response) => {
					if (response.success) {
						this.$message({
							type: "success",
							message: "提交成功",
						});
						this.loading = false;
						this.activeTop = 2
						this.$router.go(0)

						// this.$router.push("/design");
					} else {
						this.$message({
							type: "error",
							message: response.message,
						});
						this.loading = false;
					}
				});
			},
			isDesigner() {
				// console.log("isDesigner1:" + this.userMessages.uuid);
				if (this.isLogin) {
					let data = {
						userUuid: this.uuid,
					};
					if (this.uuid) {
						/*getCredentials(data).then((res) => {
						    if (res.success) {
						        if (res.data.status !== "REJECT" && res.data.identityType === "ENTERPRISE") {
						            this.$message({
						                type: "success",
						                message: "当前用户为企业用户，无法进行设计师认证！",
						            });
						        } else if (res.data.status === "REJECT" && res.data.identityType === "ENTERPRISE") {
						        } else {
						            designerByUserId(this.uuid).then((res) => {
						                if(res){
						                    this.cerStatus = res.status;
						                    this.remark = res.reason
						                    if (res.status === "PASS") {
						                        this.activeTop = 3;
						                    } else if (res.status === "AUDIT") {
						                        this.activeTop = 2;
						                    } else if (res.status === "REJECT") {
						                        this.activeTop = 3;
						                    } else if (res.status === "DRAFT") {
						                        this.activeTop = 1;
						                    }
						                    if(res.status !== "DRAFT"){
						                        this.checkedCitiesFlag = false
						                        // 数据回显
						                        this.form = res;
						                        if(res.type == 'BOTH'){
						                            this.printScreenIndex = 0;
						                            this.getPrintScreen(0);
						                            this.img1 = res.designerAttachmentList[0].fileUrl;
						                            this.work1 = res.designerAttachmentList[0].workName;
						                            this.img2 = res.designerAttachmentList[1].fileUrl;
						                            this.work2 = res.designerAttachmentList[1].workName;
						                            this.img3 = res.designerAttachmentList[2].fileUrl;
						                            this.work3 = res.designerAttachmentList[2].workName;
						                            this.img4 = res.designerAttachmentList[3].fileUrl;
						                            this.img5 = res.designerAttachmentList[5].fileUrl;
						                            this.img6 = res.designerAttachmentList[7].fileUrl;
						                            this.model1 = res.designerAttachmentList[3].workName;
						                            this.model2 = res.designerAttachmentList[5].workName;
						                            this.model3 = res.designerAttachmentList[7].workName;
						                        }else if(res.type == 'MODEL'){
						                            this.printScreenIndex = 1;
						                            this.getPrintScreen(1);
						                            this.img4 = res.designerAttachmentList[0].fileUrl;
						                            this.img5 = res.designerAttachmentList[2].fileUrl;
						                            this.img6 = res.designerAttachmentList[4].fileUrl;
						                            this.model1 = res.designerAttachmentList[0].workName;
						                            this.model2 = res.designerAttachmentList[2].workName;
						                            this.model3 = res.designerAttachmentList[4].workName;
						                        }else if(res.type == 'GRAPHIC'){
						                            this.printScreenIndex = 2;
						                            this.getPrintScreen(2);
						                            this.img1 = res.designerAttachmentList[0].fileUrl;
						                            this.work1 = res.designerAttachmentList[0].workName;
						                            this.img2 = res.designerAttachmentList[1].fileUrl;
						                            this.work2 = res.designerAttachmentList[1].workName;
						                            this.img3 = res.designerAttachmentList[2].fileUrl;
						                            this.work3 = res.designerAttachmentList[2].workName;
						                        }
						                        if (res.city === res.district) {
						                            this.value = [res.province, res.city];
						                        } else {
						                            this.value = [res.province, res.city, res.district];
						                        }
						                        res.designerGoodatList.forEach((items) => {
						                            this.checkList.push(items.goodatUuid);
						                        });
						                        if (res.designerCateList.length > 0) {
						                            this.classShow = true;
						                            res.designerCateList.forEach((items) => {
						                                let checks = [];
						                                checks = this.screenList[this.printScreenIndex].screenTwo;
						                                checks.some((item) => {
						                                    if (items.categoryUuid == item.id) {
						                                        this.checkedCities.push(item);
						                                        return true;
						                                    }
						                                })
						                            })
						                        } else {
						                            this.checkedCities = []
						                        }
						                        this.handleCheckedCitiesChange(this.checkedCities)
						                        this.checkedCitiesFlag = true
						                        // 数据回显end
						                        if (
						                            res.designerAttachmentList != null &&
						                            res.designerAttachmentList.length > 0
						                        ) {
						                            let g = 0;
						                            let m = 0;
						                            res.designerAttachmentList.forEach((item, index) => {
						                                if (item.attachmentType == "GRAPHIC") {
						                                    g++;
						                                    if (g == 1) {
						                                        this.fileList1.push(item);
						                                    } else if (g == 2) {
						                                        this.fileList2.push(item);
						                                    } else if (g == 3) {
						                                        this.fileList3.push(item);
						                                    }
						                                } else if (item.attachmentType == "MODEL_IMAGE") {
						                                    m++;
						                                    if (m == 1) {
						                                        this.fileList4.push(item);
						                                    } else if (m == 2) {
						                                        this.fileList5.push(item);
						                                    } else if (m == 3) {
						                                        this.fileList6.push(item);
						                                    }
						                                }
						                            });
						                            res.designerAttachmentList.forEach((item, index) => {
						                                if (item.attachmentType == "MODEL") {
						                                    if (
						                                        this.fileList4.length > 0 &&
						                                        item.workName == this.fileList4[0].workName
						                                    ) {
						                                        this.fileList7.push({
						                                            name: item.fileName,
						                                            url: item.fileUrl,
						                                        });
						                                    } else if (
						                                        this.fileList5.length > 0 &&
						                                        item.workName == this.fileList5[0].workName
						                                    ) {
						                                        this.fileList8.push({
						                                            name: item.fileName,
						                                            url: item.fileUrl,
						                                        });
						                                    } else if (
						                                        this.fileList6.length > 0 &&
						                                        item.workName == this.fileList6[0].workName
						                                    ) {
						                                        this.fileList9.push({
						                                            name: item.fileName,
						                                            url: item.fileUrl,
						                                        });
						                                    }
						                                }
						                            });
						                        }
						                    }
						                } else{
						                    couldIn().then((resp) => {
						                        if(resp.success){
						                            this.cerStatus = 'DRAFT'
						                            this.remark = ''
						                            this.activeTop = 0
						                            this.isIndeterminate = true
						                        }else{
						                            this.$message({
						                                type: "error",
						                                message: resp.message,
						                            });
						                        }
						                    });
						                }
						            })
						        }
						    }
						})*/
						designerByUserId(this.uuid).then((res) => {
							this.designerUserMessage = res
							if (res) {
								if (this.backUrl == "") {
									this.uuid = res.userId;
									this.backUrl = res.backIdentityUrl;
									this.cardNumValue = res.identityNo;
									this.frontUrl = res.frontIdentityUrl;
									this.name = res.name;
									this.genderIndex = res.sex === "FEMALE" ? 1 : 0;
								}

								this.cerStatus = res.status;
								this.remark = res.reason
								if (res.status === "PASS") {
									this.activeTop = 3;
								} else if (res.status === "AUDIT") {
									this.activeTop = 2;
								} else if (res.status === "REJECT") {
									this.activeTop = 3;
								} else if (res.status === "DRAFT") {
									this.activeTop = 1;
								}
								if (res.status !== "DRAFT") {
									// this.checkedCitiesFlag = false
									// 数据回显
									this.form = res;
										console.log('1111',res);
									if (res.type == 'BOTH') {
										this.printScreenIndex = 0;
										this.getPrintScreen(0);
										res.designerAttachmentList.forEach(items => {
											switch(items.workOrder){
												case 1:
												this.img1 = items.fileUrl;
												this.work1 = items.workName;
													break
												case 2:
												this.img2 = items.fileUrl;
												this.work2 = items.workName;
													break
												case 3:
												this.img3 = items.fileUrl;
												this.work3 = items.workName;
													break
												case 4:
												this.img4 = items.fileUrl;
												this.model1 = items.workName;
													break
												case 6:
												this.img5 = items.fileUrl;
												this.model2 = items.workName;
													break
												case 8:
												this.img6 = items.fileUrl;
												this.model3 = items.workName;
													break
											}
										});
									} else if (res.type == 'MODEL') {
										this.printScreenIndex = 1;
										this.getPrintScreen(1);
										res.designerAttachmentList.forEach(items => {
											switch(items.workOrder){
												case 4:
												this.img4 = items.fileUrl;
												this.model1 = items.workName;
													break
												case 6:
												this.img5 = items.fileUrl;
												this.model2 = items.workName;
													break
												case 8:
												this.img6 = items.fileUrl;
												this.model3 = items.workName;
													break
											}
										});
									} else if (res.type == 'GRAPHIC') {
										this.printScreenIndex = 2;
										this.getPrintScreen(2);
										res.designerAttachmentList.forEach(items => {
											switch(items.workOrder){
												case 1:
												this.img1 = items.fileUrl;
												this.work1 = items.workName;
													break
												case 2:
												this.img2 = items.fileUrl;
												this.work2 = items.workName;
													break
												case 3:
												this.img3 = items.fileUrl;
												this.work3 = items.workName;
													break
											}
										});
									}
									if (res.city === res.district) {
										this.value = [res.province, res.city];
									} else {
										this.value = [res.province, res.city, res.district];
									}
									res.designerGoodatList.forEach((items) => {
										this.checkList.push(items.goodatUuid);
									});
									// if (res.designerCateList.length > 0) {
									//     this.classShow = true;
									//     res.designerCateList.forEach((items) => {
									//         let checks = [];
									//         checks = this.screenList[this.printScreenIndex].screenTwo;
									//         checks.some((item) => {
									//             if (items.categoryUuid == item.id) {
									//                 this.checkedCities.push(item);
									//                 return true;
									//             }
									//         })
									//     })
									// } else {
									//     this.checkedCities = []
									// }
									// this.handleCheckedCitiesChange(this.checkedCities)
									// this.checkedCitiesFlag = true
									// 数据回显end
									if (
										res.designerAttachmentList != null &&
										res.designerAttachmentList.length > 0
									) {
										let g = 0;
										let m = 0;
										res.designerAttachmentList.forEach((item, index) => {
											if (item.attachmentType == "GRAPHIC") {
												g++;
												if (g == 1) {
													this.fileList1.push(item);
												} else if (g == 2) {
													this.fileList2.push(item);
												} else if (g == 3) {
													this.fileList3.push(item);
												}
											} else if (item.attachmentType == "MODEL_IMAGE") {
												m++;
												if (m == 1) {
													this.fileList4.push(item);
												} else if (m == 2) {
													this.fileList5.push(item);
												} else if (m == 3) {
													this.fileList6.push(item);
												}
											}
										});
										res.designerAttachmentList.forEach((item, index) => {
											if (item.attachmentType == "MODEL") {
												if (
													this.fileList4.length > 0 &&
													item.workName == this.fileList4[0].workName
												) {
													this.fileList7.push({
														name: item.fileName,
														url: item.fileUrl,
													});
												} else if (
													this.fileList5.length > 0 &&
													item.workName == this.fileList5[0].workName
												) {
													this.fileList8.push({
														name: item.fileName,
														url: item.fileUrl,
													});
												} else if (
													this.fileList6.length > 0 &&
													item.workName == this.fileList6[0].workName
												) {
													this.fileList9.push({
														name: item.fileName,
														url: item.fileUrl,
													});
												}
											}
										});
									}
								}
							} else {
								couldIn().then((resp) => {
									if (resp.success) {
										this.cerStatus = 'DRAFT'
										this.remark = ''
										this.activeTop = 0
										this.isIndeterminate = true
									} else {
										// this.$message({
										// 	type: "error",
										// 	message: resp.message,
										// });
									}
								});
							}
						})
					}
				} else {
					this.$message({
						type: "success",
						message: "您需要先登录哦！",
					});
					this.$router.push("/login");
				}
			}
		},

	};
</script>

<style scoped lang="less">
	.tableDialog{
		white-space: pre-wrap;
		/deep/p {
		  min-height: 22px;
		}
		/deep/img {
		  max-width: 100% !important;
		}
		/deep/table {
		  border: none;
		  border-collapse: collapse;
		}
		/deep/table td,
		/deep/table th{
		  border: 1px solid #ccc;
		  padding: 3px 5px;
		  min-width: 50px;
		  height: 20px;
		}
		/deep/table th {
		  border-right: 1px solid #ccc;
		  border-bottom: 2px solid #ccc;
		  text-align: center;
		  background-color: #f1f1f1;
		}
	}
	
	
	
	.messagesP {
		padding-left: 5px;
		font-size: 14px;
		color: red;
		width: 150px;
		margin: 5px 23px 0 30px
	}
	.designerBox_input{
		// /deep/ .el-input {
		// 	height: 30px;
		//   border: 1px solid #ff0000;
		//   margin-left: 10px;
		// }
		input{
			border: 1px solid #ff0000;
		}
		/deep/.el-textarea__inner{
			// width: 800px;
			// height: 100px;
			border: 1px solid #ff0000;
			 // margin-left: 15px;
		}
		// /deep/.el-input{
		// 	border: 1px solid #ff0000;
		// }
		/deep/ .el-input__inner {
		  border: 1px solid #ff0000;
		}
		
	}

	// 必填
	.mandatory {
		color: red;
		margin-right: 5px;
	}

	.span_active {
		margin-left: 20px;
		padding: 5px 20px;
		cursor: pointer;
		border-radius: 10px;
	}

	.span_activeshow {
		background: #157efb;
		color: #fff;
	}

	.designerIn {
		width: 1200px;
		margin: 0 auto 20px;
		background: #fff;
		padding-bottom: 53px;
		box-sizing: border-box;

		h4 {
			font-size: 18px;
			color: #0f0f0f;
		}

		.designerInTitle {
			border-bottom: 1px solid #e6e6e6;
			padding: 19px 13px 16px;
		}

		.steps_top {
			padding: 20px 18px;

			/deep/ .el-step.is-center .el-step__description {
				margin-top: 10px;
			}

			/deep/ .el-step__icon {
				width: 35px;
				height: 35px;
			}

			/deep/ .el-step.is-horizontal .el-step__line {
				top: 17px;
			}

			/deep/ .el-step__head.is-process {
				color: #c0c4cc;
				border-color: #c0c4cc;
			}

			.certificationErrorLine {
				/deep/ .el-step__head.is-finish {
					.el-step__line {
						border-color: #f66f6a !important;
					}
				}
			}

			.certificationError {
				/deep/ .el-step__head.is-finish {
					color: #f66f6a;
					border-color: #f66f6a !important;
				}

				/deep/ .el-step__description.is-finish {
					color: #f66f6a;
				}
			}
		}

		.certificationStatus {
			text-align: center;
			margin: 0 auto;
			width: 500px;
			padding: 20px 0 50px;

			img {
				margin-bottom: 15px;
			}

			.name {
				color: #333;
				font-size: 20px;
				padding-bottom: 10px;
			}

			.message {
				font-size: 14px;
				color: #555;

				span {
					font-weight: bold;
					color: #000;
				}
			}
		}

		// .designerProcess {
		//   height: 150px;
		//   display: flex;
		//   align-items: center;
		//   .designerProcessbox {
		//     white-space: nowrap;
		//     margin: 0 auto;
		//     position: relative;
		//     .designerProcessboxP {
		//       width: 100%;
		//       font-size: 17px;
		//       font-weight: bold;
		//       color: #ffffff;
		//       margin-bottom: 11px;
		//       text-align: center;
		//       line-height: 44px;
		//       display: flex;
		//       align-items: center;
		//       justify-content: center;

		//       p {
		//         width: 44px;
		//         height: 44px;
		//         background: #e8e8e8;
		//         border-radius: 50%;
		//       }
		//       .designerProNum {
		//         background: #157efb;
		//       }
		//     }

		//     span {
		//       font-size: 14px;
		//       color: #5c5c5c;
		//     }
		//   }
		//   .designerProcessHe {
		//     width: 390px;
		//     height: 4px;
		//     background: #e8e8e8;
		//     position: absolute;
		//     top: 20px;
		//     left: 56px;
		//   }
		// }
		.designerInMess {
			.designerID {
				margin: 23px 0 34px;

				.designerIDmes {
					margin-right: 142px;
					text-align: center;

					img {
						width: 271px;
						height: 169px;
						margin-bottom: 6px;
						border-radius: 22px;
					}

					p {
						font-size: 12px;
						color: #c6c6c6;
					}
				}
			}

			.designerIDcon {
				margin-bottom: 40px;

				.designerIDconbox {
					font-size: 14px;
					margin-bottom: 38px;
					white-space: nowrap;

					.designerIDconboxN {
						align-items: center;
						flex-shrink: 0;
					
						
						p {
							flex-shrink: 0;
							width: 56px;
						}
						/deep/.el-input__inner{
							height: 40px;
							border-radius: 4px;
							margin: 0 23px 0 30px;
							padding-left: 10px;
							box-sizing: border-box;
							color: #606266;
						}
						input {
							height: 40px;
							background: #fafafa;
							border-radius: 4px;
							border: none;
							margin: 0 23px 0 30px;
							padding-left: 10px;
							box-sizing: border-box;
							color: #606266;

							&::-webkit-input-placeholder {
								/* WebKit browsers */
								color: #cacaca;
							}

							&::-moz-placeholder {
								/* Mozilla Firefox 19+ */
								color: #cacaca;
							}

							&:-ms-input-placeholder {
								/* Internet Explorer 10+ */
								color: #cacaca;
							}
						}

						.cascaderInput {
							// margin: 0 23px 0 30px;
							// width: 234px;
							height: 40px;
							// background: #fafafa;
							border-radius: 4px;

							/deep/ .el-input__inner {
								width: 200px;
								// background-color: #fafafa;
								// border: none !important;
								font-size: 14px;
							}
							/deep/ .el-input__suffix{
								right: 30px;
							}
						}

						button {
							width: 50px;
							height: 40px;
							background: #fafafa;
							border-radius: 4px;
							margin-left: 23px;

							border: none;
							cursor: pointer;
						}

						.buttonActive {
							background: #157efb;
							color: #fff;
						}
					}

					
				}
			}
		}
		
/deep/.el-textarea__inner{
							margin-left: 30px;
							width: 800px;
							height: 80px;
							border-radius: 4px;
							color: #606266;
							padding: 10px;
							box-sizing: border-box;
						}
		.designerClass {
			white-space: normal;
			margin-bottom: 20px;

			.desTopClass {
				.typeName {
					font-size: 14px;
					width: 85px;
					letter-spacing: 23px;
				}

				.destoPone {
					p {
						margin-bottom: 10px;
						margin-right: 0px;
						padding: 3px 14px;
						font-size: 14px;
					}

					.materDetailsT {
						// background: #157efb;
						color: #157efb;
						border-radius: 5px;
						padding: 3px 15px;
						margin-bottom: 10px;
					}
				}

				.print_screen_boxP {
					display: flex;
					flex-wrap: wrap;

					p {
						cursor: pointer;
						margin-bottom: 10px;
						margin-right: 0px;
						padding: 3px 14px;
						font-size: 14px;
					}

					.screen_text {
						color: #157efb;
						background: #157efb;
						border-radius: 5px;
						margin-bottom: 10px;
						color: #fff;
						padding: 3px 15px;
						font-size: 14px;
						cursor: pointer;
					}
				}

				ul {
					display: flex;

					li {
						padding: 5px 12px;
						cursor: pointer;
						margin-right: 10px;

						&.active {
							color: #fff;
							background: #157efb;
							border-radius: 4px;
						}
					}
				}
			}
		}

		.goodAtClass {
			margin-bottom: 25px;

			.goodAtClassT {
				width: 56px;
				font-size: 14px;
				margin-right: 23px;
			}
		}

		.desinerInWorks {
			h4 {
				margin-bottom: 30px;
			}

			.desinerInWorksbox {
				width: 320px;

				.upload-demoss {
					width: 320px;
					height: 215px;
					background: #fafafa;
					opacity: 1;
					border-radius: 4px;
					margin-bottom: 20px;
					position: relative;

					.img-avatar {
						width: 320px;
						height: 215px;
					}

					.upload-demobox {
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);

						.imgsBox {
							position: relative;

							i {
								position: absolute;
								bottom: 10px;
								right: 10px;
								width: 34px;
								height: 34px;
								background: #ffffff;
								opacity: 0.44;
								border-radius: 4px;
								color: #157efb;
								font-size: 25px;
								display: inline-block;
								text-align: center;
								line-height: 34px;
								font-weight: bold;
								cursor: pointer;
							}
						}

						.demoboxAdd {
							text-align: center;
							cursor: pointer;

							.file {
								position: relative;
								display: inline-block;
								overflow: hidden;
								text-decoration: none;
								text-indent: 0;
								width: 62px;
								height: 62px;
								background: #157efb;
								border-radius: 50%;
								margin-bottom: 16px;
								font-size: 62px;
								color: #fff;
								line-height: 55px;
							}

							.file input {
								// opacity: 0;
								width: 62px;
								height: 62px;
								position: absolute;
								font-size: 100px;
								right: 0;
								top: 0;
								opacity: 0;
								cursor: pointer;
							}

							span {
								cursor: pointer;
								position: absolute;
								top: 50%;
								left: 50%;
								transform: translate(-50%, -50%);
							}
						}

						p {
							font-size: 12px;
							color: #c6c6c6;
							white-space: nowrap;
							text-align: center;
						}
					}
				}

				.desinerInWorksname {
					font-size: 14px;
					align-items: center;
					white-space: nowrap;

					.desinerInWorksnamec {
						font-size: 8px;
						color: #c6c6c6;
						margin-top: 7px;
						text-align: right;
					}

					p {
						margin-right: 15px;
					}

					input {
						width: 249px;
						height: 40px;
						// background: #fafafa;
						border-radius: 4px;
						border: 1px solid #DCDFE6;
						padding-left: 10px;
						box-sizing: border-box;
					}

					button {
						width: 237px;
						height: 40px;
						background: #157efb;
						border-radius: 4px;
						color: #fff;
						border: none;
						cursor: pointer;
					}

					/deep/ .upload-demo {
						width: 237px;
					}
				}
			}
		}

		.successButtonBox {
			width: 100%;
			margin: 53px auto 0;
			text-align: center;

			.successButton {
				cursor: pointer;
				width: 80px;
				height: 40px;
				background: #157efb;
				border-radius: 4px;
				color: #fff;
				font-size: 16px;
				border: none;
			}
		}
	}

	.crollba {
		/deep/.el-scrollbar__wrap {
			overflow: auto;
		}
	}

	// 入驻信息
	.information {
		border: 1px solid #efefef;
		border-radius: 5px;
		padding: 15px;
		margin: 20px 50px;

		h5 {
			font-size: 16px;
			margin-bottom: 20px;
		}

		.information_top {
			display: flex;
			flex-wrap: wrap;
			font-size: 14px;
			color: #666;

			.information_one_box {
				display: flex;
				width: 50%;
				margin-bottom: 20px;

				.information_one_box_title {
					width: 160px;
					text-align: right;
					margin-right: 20px;
				}

				span {
					color: #333;
				}

				.information_img {
					width: 80px;
					height: 50px;
					margin-right: 15px;
					position: relative;
					cursor: pointer;
					
					/deep/ .el-image{
						width: 100%;
						height: 100%;
					}
					&:hover .information_img_text {
						display: flex;
					}

					img {
						width: 100%;
						height: 100%;
					}

					.information_img_text {
						display: none;
						align-items: center;
						justify-content: center;
						font-size: 12px;
						color: #fff;
						width: 100%;
						height: 20px;
						line-height: 20px;
						background: rgb(85 85 85 / 73%);
						position: absolute;
						bottom: -9px;

						i {
							margin-right: 5px;
						}
					}
				}
			}
		}

		.information_bottom {
			.information_two_box {
				font-size: 14px;
				color: #666;
				display: flex;
				margin-bottom: 20px;

				.information_two_box_title {
					width: 160px;
					text-align: right;
					margin-right: 20px;
				}

				span {
					color: #333;
				}

				.information_img {
					width: 80px;
					height: 40px;
					margin-right: 15px;
					position: relative;
					cursor: pointer;
					
					/deep/ .el-image{
						width: 100%;
						height: 100%;
					}
					&:hover .information_img_text {
						display: flex;
					}

					img {
						width: 100%;
						height: 100%;
					}

					.information_img_text {
						display: none;
						align-items: center;
						justify-content: center;
						font-size: 12px;
						color: #fff;
						width: 100%;
						height: 20px;
						line-height: 20px;
						background: rgb(85 85 85 / 73%);
						position: absolute;
						bottom: 0;

						i {
							margin-right: 5px;
						}
					}
				}
			}

		}

	}
</style>



// WEBPACK FOOTER //
// src/components/design/designerIn.vue